import { KbAdminEditorAiDetails } from "./KbAdminEditorAiDetails";
import { KbAdminEditorSplitSection } from "./KbAdminEditorSplitSection";
import type { KbAdminEditorSectionProps } from "./kbAdminEditorProps";
import { FIREFLY_TARGET_ATTR } from "@/lib/firefly/fireflyTargetConvention";
import { SectionCard } from "./SectionCard";
import { KbEditorBodyAndPills } from "./editor/KbEditorBodyAndPills";
import { KbEditorSaveDock } from "./editor/KbEditorSaveDock";
import { KbEditorTopFields } from "./editor/KbEditorTopFields";
import { useKbEditorSaveScroll } from "./editor/useKbEditorSaveScroll";

export type { KbAdminEditorSectionProps, KbDictationControls } from "./kbAdminEditorProps";

export function KbAdminEditorSection(props: KbAdminEditorSectionProps) {
  const { articleContent } = props;

  const { articleBodyHadBlurWithText, setArticleBodyHadBlurWithText, saveSectionRef, scrollToSaveSection } =
    useKbEditorSaveScroll(articleContent);

  const showToolGlow = articleBodyHadBlurWithText && articleContent.trim().length > 0;

  return (
    <div {...{ [FIREFLY_TARGET_ATTR]: "kb-editor-panel" }}>
    <SectionCard
      title="Editor"
      description="One article at a time: set title and permissions, write the body, then review how search segments your text before saving."
    >
      <div className="space-y-4">
        <KbEditorTopFields {...props} />

        <KbEditorBodyAndPills
          {...props}
          showToolGlow={showToolGlow}
          setArticleBodyHadBlurWithText={setArticleBodyHadBlurWithText}
        />

        <KbAdminEditorAiDetails {...props} />

        <KbAdminEditorSplitSection {...props} />

        <KbEditorSaveDock {...props} saveSectionRef={saveSectionRef} scrollToSaveSection={scrollToSaveSection} />
      </div>
    </SectionCard>
    </div>
  );
}
